<template>
  <el-cascader :ref="refs" :placeholder="placeholder" :popper-class="refs" @visible-change="visibleChange" @expand-change="visibleChange" :disabled="disabled" :options="datas" collapse-tags :props="props" filterable v-model="ids"
    @change="checkChange" :show-all-levels="showAllLevels" :clearable="clearable"></el-cascader>
</template>

<script>
export default {
  props: {
    value: "",
    showAllLevels: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
      default: () => { return {} },
    },
    root: 0,
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultDisabled: {
      type: Array,
      default: () => { return [] },
    },
    sourceType: "",
    placeholder: {
      type: String,
      default: "请选择"
    }
  },
  data() {
    return {
      datas: [],
      checkedKeys: [],
      ids: "",
      props: {
        // checkStrictly: true,
        label: "name",
        value: "id",
        emitPath: false,
      },
      isFirst: true,
      hasChildren: false,
    }
  },
  watch: {
    value: function (newValue) {
      this.ids = newValue;
      if (this.ids && this.isFirst) {
        this.checkChange(this.ids)
        this.isFirst = false;
      }
    },
    defaultDisabled() {
      this.setChildren(this.datas);
    }
  },
  beforeDestroy() {
    this.$bus.$off('major_update')
  },
  created() {
    this.props = Object.assign(this.props, this.config);
    if (typeof this.config.checkStrictly != "boolean") {
      this.props.checkStrictly = true;
    }
    this.refs = "majors_" + new Date().getTime();
  },
  mounted() {
    this.ids = this.value;
    this.$bus.$on("major_update", data => {
      this.getData();
    })
    this.getData();
  },
  methods: {
    getData() {
      let params = {
        pId: 0,
      }
      this.loading = true;
      this.https("get", "/api/Major/GetMajorTree", params).then(res => {
        this.loading = false;
        let data = res.response.children || [];
        this.setDatas(data);
      }).catch(() => {
        this.loading = false;
      })
    },
    setDatas(data) {
      this.datas = data;
      this.setChildren(this.datas);
      if (!this.hasChildren && this.props.checkStrictly) {
        this.props.checkStrictly = false;
      }
      if (this.ids && this.isFirst) {
        this.checkChange(this.ids)
        this.isFirst = false;
      }
    },
    setChildren(arr) {
      arr.map(item => {
        if (this.props.checkStrictly === false && item.type == 1) {
          item.children = item.children || [];
        }
        if (this.defaultDisabled.indexOf(item.id) >= 0) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
        if (item.children && item.children.length > 0) {
          this.setChildren(item.children);
          this.hasChildren = true;
        }
      })
    },
    checkChange(val) {
      this.$emit('input', val);
      setTimeout(() => {
        let checkedNodes = this.$refs[this.refs].getCheckedNodes().filter(item => item != null);
        let node = checkedNodes.find(item => item.value == val);
        if (node) {
          this.$emit('change', node.data);
        }
      });
      this.isFirst = false;
    },
    visibleChange(val) {
      if (this.props.checkStrictly && val) {
        setTimeout(() => {
          var depts = document.getElementsByClassName(this.refs)[0];
          var btns = depts.getElementsByClassName('el-radio__inner');
          for (let i = 0; i < btns.length; i++) {
            btns[i].onclick = () => {
              this.$refs[this.refs]._data.dropDownVisible = false;
            }
          }
        }, 200);
      }
    },
  },
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/MajorCascader.vue